import $http from '../../axios-instance';
import Swal from 'sweetalert2';
import {Notification} from 'element-ui';

/**
 * Método para obtener los estados de un producto químico.
 *
 * @param {*} param0
 */
export async function getEstados({commit}) {
    commit('dashboard/load', true, {root: true});
    await $http.get('controles/18')
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('cargarEstados', response.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            console.log(error);
        });
}

/**
 * Obtener empresas
 *
 * @param {*} nombre empresa
 */
export async function getEmpresas({commit}, nombre) {

    if (nombre && nombre.length >= 3) {
        try {
            commit('dashboard/load', true, {root: true});
            const response = await $http.get('/empresas/lista', {params: {nombre}})
            commit('setEmpresas', response.data.data);
        } catch (error) {
            if (this.$vue.$alertErrorsCallback(error)) return;
            this.$vue.$alertError(error.message);
        } finally {
            commit('dashboard/load', false, {root: true});
        }
    }
}


/**
 * Método para obtener los usuarios de MYS que deben ser responsables de algun ticket.
 *
 * @param {*} param0
 */
export async function getUsuarios({state, commit, rootState}) {
    if (rootState.autenticacion.usuarioAdmin) {
        commit('dashboard/load', true, {root: true});
        await $http.get('usuarios/responsables')
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                commit('setUsuarios', response.data);
            })
            .catch((error) => {
                commit('dashboard/load', false, {root: true});
                console.log(error);
            });
    }
}

/**
 * Método para agendar la descarga masiva de tickets.
 *
 * @export
 * @param {*} { commit, state}
 * @param {*} data
 */
export async function fetchTicketsReport({commit, state}, data) {
    commit('dashboard/load', true, {root: true});
    await $http.post(`empresas/procesamientos_background/INFORME-TICKETS`, data)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 6000
            });
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br >' + error.errors,
                showConfirmButton: false,
                timer: 2000
            });
        });
}

/**
 * Método para agendar la descarga masiva de tickets.
 *
 * @export
 * @param {*} { commit, state}
 * @param {*} data
 */
export async function getTicketsReports({commit, state}, data) {
    commit('dashboard/load', true, {root: true});
    await $http.get(`empresas/procesamientos_background/INFORME-TICKETS`)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setInformesProcesados', response.data.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br >' + error.errors,
                showConfirmButton: false,
                timer: 2000
            });
        });
}

/**
 * Método para descargar el informe de tickets.
 *
 * @param {*} param0
 * @param {*} id id del agendamiento
 */
export async function downloadReport({commit, state}, id) {
    commit('dashboard/load', true, {root: true});
    await $http.post(`empresas/procesamientos_background/INFORME-TICKETS/${id}`)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setTicketsReport', response.data);
            state.error = false;
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: false,
                timer: 2000
            })
            state.error = true;
        })
}

/**
 * Método para eliminar un reporte agendado.
 *
 * @export
 * @param {*} {commit, state}
 * @param {*} data
 */
export async function eliminarReporteAgendado({commit, state}, data) {
    await $http.delete(`empresas/procesamientos_background/INFORME-TICKETS/${data.id_empresa}/${data.id}`)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br >' + error.errors,
                showConfirmButton: false,
                timer: 2000
            });
        });
}

/**
 * Método para eliminar todos los reportes agendados.
 *
 * @export
 * @param {*} {commit}
 */
export async function eliminarTodosReportesAgendados({commit}) {
    commit('dashboard/load', true, {root: true});
    await $http.delete(`empresas/procesamientos_background/INFORME-TICKETS`)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br >' + error.errors,
                showConfirmButton: false,
                timer: 2000
            });
        });
}

export async function guardaTicket({commit, state, rootState, dispatch}, data) {
    commit('dashboard/load', true, {root: true});
    await $http.post('/tickets/crear', data)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: "Tickets",
                text: response.data.message,
                showConfirmButton: true
            });
            commit('limpiarTicket');
            //dispatch('guardaAsignacion', response.data.ticket_max);
            dispatch('listarTickets');

            state.error = false;
        })
        .catch((error) => {
            state.error = true;
            commit('dashboard/load', false, {root: true});
            if (this.$vue.$alertErrorsCallback(error)) return;
            this.$vue.$alertError(error.message,3500);
        });
}

export function setPerPagePagination({commit, dispatch, state}, perPage) {
    commit('setPerPage', parseInt(perPage));
    dispatch('listarTickets');
}


export async function guardaTicketContacto({commit, state, rootState, dispatch}, data) {

    data.append('empresa', rootState.tickets.selectedTicket.empresa);
    data.append('asunto', rootState.tickets.selectedTicket.asunto);
    data.append('nombre', rootState.tickets.selectedTicket.nombre);
    data.append('mensaje', rootState.tickets.selectedTicket.mensaje);
    data.append('email', rootState.tickets.selectedTicket.email);

    await $http.post('/tickets/contacto/crear', data)
        .then((response) => {
            commit('limpiarTicket');
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.errors,
                showConfirmButton: false,
                timer: 5000
            });
        });
}

/**
 *
 *
 * @export
 * @param {*} {state, commit}
 * @param {*} data
 */
export async function listarListasPorCodigo({state, commit}, data) {
    commit('dashboard/load', true, {root: true});
    await $http.get(`adm_general/listas-por-codigo/mostrar/${data.codigo}`, {params: data})
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit(data.servicio, response.data, {root: true})
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.errors,
                showConfirmButton: false,
                timer: 2000
            });
        })
}

/**
 * Método para obtener los tickets registrados
 *
 * @export
 * @param {*} {state, commit}
 * @param {*} [requestParameters={params: state.filtroEt}]
 */
export async function listarTickets({state, commit}, requestParameters = {params: state.filtroEt}) {
    commit('dashboard/load', true, {root: true});
    await $http.get('/tickets', requestParameters)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setListarTickets', response.data.data);

        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.errors,
                showConfirmButton: false,
                timer: 2000
            });
        });
}

/**
 * Método para cambiar la pagina de las observaciones masivas de los tickets.
 *
 * @param {*} param0
 * @param {*} page contiene la pagina.
 */
export async function setPagePaginationMasivo({commit, dispatch, state}, page) {
    commit('setPageMasivo', parseInt(page));
    await dispatch('listarListasPorCodigo', state.filtrosListas);
}

/**
 * Método para cambiar la cantidad por pagina de las observaciones masivas de los tickets.
 *
 * @export
 * @param {*} {commit, dispatch, state}
 * @param {*} perPage
 */
export async function setPerPagePaginationMasivo({commit, dispatch, state}, perPage) {
    commit('setPageMasivo', 1);
    commit('setPerPageMasivo', parseInt(perPage));
    await dispatch('listarListasPorCodigo', state.filtrosListas);
}


export async function detallarTicket({state, commit, dispatch}, id) {
    commit('dashboard/load', true, {root: true});
    await $http.get('/tickets/ver/' + id)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});

            commit('resetDetailsTicket');
            commit('cambiaTicketId', response.data.data);

            await dispatch('obtieneObservaciones', id);
            commit('setPantalla', 'detalleTicket');
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Método para registrar las observaciones de forma masiva.
 *
 * @export
 * @param {*} {commit, state}
 * @param {*} data contiene el id de los tickets y la observación
 */
export async function guardarObservacionMasivo({commit, state}, data) {
    commit('dashboard/load', true, {root: true});
    await $http.post('/observacionTickets/masivo/crear', data)
        .then((response) => {
            if (response.data.errors) {
                response.data.errors.forEach(message => {
                    setTimeout(() => {
                        Notification.error({
                            title: 'Error',
                            message: message,
                            type: 'success',
                            duration: 5000,
                            customClass: 'notification-box',
                        });
                    }, 1000);
                });
            }

            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        })
}

/**
 * Método para asignar un profesional de forma masiva.
 *
 * @export
 * @param {*} {commit, state}
 * @param {*} data contiene el id de los tickets y el profesional asignado
 */
export async function guardarProfesionalMasivo({commit, state}, data) {
    commit('dashboard/load', true, {root: true});
    await $http.put('/tickets/profesional/masivo/editar', data)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        })
}

/**
 * Método para asignar un estado de forma masiva a tickets.
 *
 * @export
 * @param {*} {commit, state}
 * @param {*} data contiene el id de los tickets y el profesional asignado
 */
export async function actualizarEstadoMasivo({commit, state}, data) {
    commit('dashboard/load', true, {root: true});
    await $http.put('/tickets/estado/masivo/editar', data)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        })
}

export async function guardaObservacion({commit, state, dispatch, rootState}, data) {
    state.selectedObservacion.id_ticket = state.ticket_detalle.id;


    data.append('observacion', state.selectedObservacion.observacion);
    data.append('id_ticket', state.selectedObservacion.id_ticket);

    await $http.post('/observacionTickets/crear', data)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });

            dispatch('obtieneObservaciones', state.selectedObservacion.id_ticket);
            commit('limpiarObservacion');
            state.error = false;
        })
        .catch((error) => {
            throw new Error(`${error.message}`);
        });

}

export async function obtieneObservaciones({commit, state}, id) {
    commit('dashboard/load', true, {root: true});
    await $http.get(`/observacionTickets/ver/${id}`)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setObservaciones', response.data.data);

            state.error = false;
        })
        .catch(() => {
            commit('dashboard/load', false, {root: true});
        });
}

export async function actualizarVisto({commit, state}, id) {
    commit('dashboard/load', true, {root: true});
    await $http.put(`/observacionTickets/visto/${id}`, state.vistoUsuario)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setVisto', response.data.data);
            state.error = false;
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
        });
}

export function setPagePagination({commit, dispatch, state}, page) {

    commit('setPage', parseInt(page));
    dispatch('listarTickets');
}

export async function descargarAdjunto({state}, documento) {
    let urlServicio = '';
    let nombre = '';
    if (documento.tipo == 'ticket') {
        urlServicio = 'ticket/adjuntos/download/';
        nombre = 'Ticket#' + documento.idTicket + ' ' + documento.asunto + '.' + documento.extension;
    } else {
        urlServicio = 'observacionTickets/adjuntos/download/';
        nombre = 'Ticket#' + state.ticket_detalle.idTicket + 'obs.' + documento.extension;
    }

    await $http({
        url: urlServicio + documento.id,
        method: 'GET',
        responseType: 'blob'
    }).then((response) => {
        window.downloadFile(response.data, nombre);
    }).catch(async (error) => {
        const res = await new Response(error).text();
        const response = JSON.parse(res);
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: response.message,
            showConfirmButton: true,
            timer: 5000
        });
    });
}

/**
 * Método para actualizar la información de un ticket.
 *
 * @export
 * @param {*} {state, commit, dispatch}
 * @param {*} data
 */
export async function actualizarTicket({state, commit, dispatch}, data) {
    commit('dashboard/load', true, {root: true});
    await $http.put('/tickets/editar/' + state.ticket_detalle.id, data)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: true,
                timer: 2000
            });
            dispatch('detallarTicket',state.ticket_detalle.id)
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
        });
}



/**
 * Método para actualizar la información de un ticket.
 *
 * @export
 * @param {*} {state, commit, dispatch}
 * @param {*} data
 */
export async function cancelTicket({state, commit, dispatch}, data) {
    commit('dashboard/load', true, {root: true});
    await $http.patch('/tickets/cancelar-ticket/' + data.id, data)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('updateTicket', response.data.ticket);
            commit('addObservation', response.data.observation);
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'El ticket ha sido cerrado correctamente',
                showConfirmButton: true,
                timer: 2000
            });
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener data para graficas de tickets
 * @param payload
 * @autor Paul Valencia
 */
export async function geTicketInfoForGraphs({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`/tickets/info-graphics`, { params: payload});
        commit('setInfoCharts',response.data.data)
        return response.data;
    } catch (error) {
        if (error.message) {
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        }
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Obtener empresa asociada al usuario.
 *
 * @autor Paul Valencia
 */
export async function getMyCompany({commit}) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get('/mi-empresa/lista');
        if (response.data.length) {
            commit('setEmpresas', response.data);
            return Promise.resolve(response.data[0]);
        }
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}
